export default {
  canDisplaySectionResults: false,
  survey: {
    response: ''
  },
  pointers: {
    section: -1,
    statement: -1
  },
  pusher: null
}
